import React, { useState, useEffect } from 'react';
import './Infra.css'; // Ensure this matches your CSS filename
import Navbar from '../components/navbar';
import Footer from '../components/Footer';
import PageHeader from '../about/PageHeader';

// 1. Image List - Updated to arrays for the carousel
const images = {
  labs: [
    "/Infra/Computer_labs_webp_images/Untitled-1.webp",
    "/Infra/Computer_labs_webp_images/Untitled-2.webp",
    "/Infra/Computer_labs_webp_images/Untitled-3.webp",
    "/Infra/Computer_labs_webp_images/Untitled-4.webp",
    "/Infra/Computer_labs_webp_images/Untitled-5.webp",
    "/Infra/Computer_labs_webp_images/Untitled-6.webp",
    "/Infra/Computer_labs_webp_images/Untitled-7.webp",
    "/Infra/Computer_labs_webp_images/Untitled-8.webp"
  ],
library: [
    "/Infra/Tall_side_card_library_webp_images/Untitled-1.webp",
    "/Infra/Tall_side_card_library_webp_images/Untitled-2.webp",
    "/Infra/Tall_side_card_library_webp_images/Untitled-3.webp"
  ],
classroom: [
    "/Infra/standardCards_ClassRooms_Seminar_Hall/Untitled-1.webp",
    "/Infra/standardCards_ClassRooms_Seminar_Hall/Untitled-2.webp",
    "/Infra/standardCards_ClassRooms_Seminar_Hall/Untitled-3.webp",
    "/Infra/standardCards_ClassRooms_Seminar_Hall/Untitled-4.webp"
  ],
seminar: [
    "/Infra/standardCards_ClassRooms_Seminar_Hall/Untitled-5.webp",
    "/Infra/standardCards_ClassRooms_Seminar_Hall/Untitled-6.webp"
  ],
hostel: [
    "/Infra/Common_room_webp_images/Untitled-1.webp",
    "/Infra/Common_room_webp_images/Untitled-2.webp",
    "/Infra/Common_room_webp_images/Untitled-3.webp",
    "/Infra/Common_room_webp_images/Untitled-4.webp",
    "/Infra/Common_room_webp_images/Untitled-5.webp",
    "/Infra/Common_room_webp_images/Untitled-6.webp"
  ],
sickroom: [
  "/Infra/sick_room/MCA05861.JPG",
  "/Infra/sick_room/MCA05862.JPG"
],
compCentre: [
    "/Infra/Computer_labs_webp_images/Untitled-6.webp",
    "/Infra/Computer_labs_webp_images/Untitled-7.webp",
    "/Infra/Computer_labs_webp_images/Untitled-8.webp"
  ],
  // Gallery Images (kept as single strings for the static bottom grid)
g1: "/Infra/standard_mixed_grid_webp/600x850_webp/Untitled-2.webp",
  g2: "/Infra/standard_mixed_grid_webp/600x400/Untitled-2.webp",
  g3: "/Infra/standard_mixed_grid_webp/600x400/Untitled-3.webp",
  g4: "/Infra/standard_mixed_grid_webp/600x400/image00001.jpeg",
g5: "/Infra/standard_mixed_grid_webp/1200x400_webp/Untitled-5.webp", 
 g6: "/Infra/standard_mixed_grid_webp/600x400/Untitled-4.webp",
  g7: "/Infra/standard_mixed_grid_webp/600x400/Untitled-5.webp",
  g8: "/Infra/standard_mixed_grid_webp/600x400/Untitled-6.webp",
  g9: "/Infra/standard_mixed_grid_webp/600x850_webp/Untitled-3.webp", // Recycled image (only 6 provided in folder)
g10: "/Infra/standard_mixed_grid_webp/1800x400/Untitled-1.webp",
g11: "/Infra/standard_mixed_grid_webp/1200x400_webp/Untitled-4.webp", 
};

// 2. Carousel Component
const ImageCarousel = ({ imageArray }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === imageArray.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? imageArray.length - 1 : prev - 1));
  };

  // Auto-play effect
  useEffect(() => {
    if (!imageArray || imageArray.length <= 1) return;
    
    // Set up the interval for auto-sliding every 3 seconds
    const slideInterval = setInterval(nextSlide, 3000);

    // Clean up the interval on component unmount or when dependencies change
    return () => clearInterval(slideInterval);
  }, [currentIndex, imageArray]); // Adding currentIndex resets timer if user clicks a button manually

  if (!imageArray || imageArray.length === 0) return null;

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%', overflow: 'hidden' }}>
      <img 
        src={imageArray[currentIndex]} 
        alt="Infrastructure Carousel" 
        className="ui-infra-img" 
        style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'all 0.3s ease' }} 
      />
      
      {/* Navigation Buttons */}
      {imageArray.length > 1 && (
        <>
          <button 
            onClick={prevSlide} 
            style={{ 
              position: 'absolute', top: '50%', left: '10px', transform: 'translateY(-50%)', 
              background: 'rgba(0,0,0,0.5)', color: '#fff', border: 'none', borderRadius: '50%', 
              width: '32px', height: '32px', cursor: 'pointer', zIndex: 2, display: 'flex', 
              alignItems: 'center', justifyContent: 'center', fontSize: '16px' 
            }}
          >
            &#10094;
          </button>
          <button 
            onClick={nextSlide} 
            style={{ 
              position: 'absolute', top: '50%', right: '10px', transform: 'translateY(-50%)', 
              background: 'rgba(0,0,0,0.5)', color: '#fff', border: 'none', borderRadius: '50%', 
              width: '32px', height: '32px', cursor: 'pointer', zIndex: 2, display: 'flex', 
              alignItems: 'center', justifyContent: 'center', fontSize: '16px' 
            }}
          >
            &#10095;
          </button>

          {/* Dots Indicator */}
          <div style={{ 
            position: 'absolute', bottom: '10px', left: '50%', transform: 'translateX(-50%)', 
            display: 'flex', gap: '6px', zIndex: 2 
          }}>
            {imageArray.map((_, idx) => (
              <span 
                key={idx} 
                onClick={() => setCurrentIndex(idx)} 
                style={{ 
                  width: '8px', height: '8px', borderRadius: '50%', cursor: 'pointer',
                  background: currentIndex === idx ? '#fff' : 'rgba(255,255,255,0.5)',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.5)'
                }}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

// 3. Helper Component for "Read More" functionality
const ReadMoreDesc = ({ text, limit }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // If text is short enough, render it normally
  if (text.length <= limit) return <div className="ui-infra-desc">{text}</div>;

  return (
    <div className="ui-infra-desc">
      {isExpanded ? text : text.substring(0, limit) + "..."}
      <span 
        className="ui-infra-read-more-link" 
        onClick={() => setIsExpanded(!isExpanded)}
        style={{ cursor: 'pointer', fontWeight: 'bold', marginLeft: '5px', textDecoration: 'underline' }}
      >
        {isExpanded ? " Read Less" : " Read More"}
      </span>
    </div>
  );
};

const Infrastructure = () => {
  // --- Updated Content Strings ---

  const computerLabsText = "The Institute has Four state-of-the-art Laboratories and connected in LAN. Computer Lab 1 & Computer Center 2 are i5 machines for a batch size of 30 in each lab are exclusively used for database programming and application programming. It has Oracle 9i & 11g, IBM Rational Suit, C, C++, Java installed in the client server environment. It has Window 7 operating system installed";
  
  const libraryText = "The Institute Library is enriched with Books, e-Books, e-Journals, Journals (National & International), Magazine & Newspapers. There are 13483 books related to Computers, 4200 e-book, 6 National Journals and International Journals, 190 IEEE ASPP International (e-journals), 1200 CD’s and students project reports catering to the needs of students in research and project areas. The Digital Library is fully air-conditioned with 9 Terminals (Dell opti-plex i3 18.5 inches LCD monitor) 4 access points for Laptops and high-speed internet connection (@ 50 Mbps) to accesses e-resources ie. E-Books – EBSCOhost-e-Book ITCore Collection, e-Journals – IEEE International, NPTEL, Swayam, NDL, Koha – OPAC, soft copy of question papers and syllabus. The Library is fully air-conditioned & well furnished with seating capacity of 100 seats. Journals display rack and tables for study and news paper reading. Library is computerised with Koha software. Book Bank facility is available for all students. Book Exhibition is organized every year to enhance and update Library collection.";

  const classRoomText = "The Institute has spacious classrooms, which are fully air-conditioned. They possess all necessary teaching aids like LCD, Overhead Projector, Internet Communication and LAN Supported Systems for teaching purposes. Classrooms are well designed so that teaching can take place in peaceful and comfortable conditions.";

  const computerCentreText = "This Laboratory is used for in-house project development by the students. The computers with Linux and Windows 10 operating system have Visual Studio, Java, Oracle, .Net technology, Crystal Report, J Builder and Macromedia packages installed. The broadband Internet connectivity of 32 Mbps is provided in this laboratory.";

  const seminarHallText = "The Institute has spacious Seminar Hall, which is fully air-conditioned. It possess all necessary teaching aids like LCD, Overhead Projector, Internet Communication and LAN Supported Systems for training and teaching purposes. It is well designed so that activities, events, workshops,seminars and teaching can take place in peaceful and comfortable conditions.";

  const sickRoomText = "There is a medical room in the campus where the students can take rest, if they are unwell.";

  // Combined Hostel and Common Room text for the footer card
  const hostelText = "Thakur Institute of Management Studies, Career Development and Research provide the facility of boys hostel. Well furnished, spacious, airy comfortable rooms, water facilities and recreational activities make students feel at home. To recharge the students with energy, there is a gymkhana for them. It includes indoor games varying from chess, carom and table tennis.";

  return (
    <>
      <Navbar />
      <PageHeader
        title="Infrastructure"
        crumbs={[{ label: "Home", href: "/" }, { label: "Infrastructure" }]}
      />

      <div className="ui-infra-container">
        
        {/* --- Main Mosaic Grid --- */}
        <div className="ui-infra-grid">
          
          {/* 1. Hero: Computer Labs */}
          <div className="ui-infra-card ui-infra-card-overlay ui-pos-hero">
            <div className="ui-infra-img-wrapper">
              <ImageCarousel imageArray={images.labs} />
            </div>
            <div className="ui-infra-content">
              <div className="ui-infra-heading">Computer Labs</div>
              <ReadMoreDesc text={computerLabsText} limit={180} />
            </div>
          </div>

          {/* 2. Tall Left: Library */}
          <div className="ui-infra-card ui-infra-card-overlay ui-pos-tall">
            <div className="ui-infra-img-wrapper">
              <ImageCarousel imageArray={images.library} />
            </div>
            <div className="ui-infra-content">
              <div className="ui-infra-heading">Library</div>
              <ReadMoreDesc text={libraryText} limit={200} />
            </div>
          </div>

          {/* 3. Right Stack Top: Class Rooms */}
          <div className="ui-infra-card ui-infra-card-standard ui-pos-standard">
            <div className="ui-infra-img-wrapper">
              <ImageCarousel imageArray={images.classroom} />
            </div>
            <div className="ui-infra-content">
              <div className="ui-infra-heading">Class Rooms</div>
              <ReadMoreDesc text={classRoomText} limit={120} />
            </div>
          </div>

          {/* 4. Right Stack Bottom: Seminar Hall */}
          <div className="ui-infra-card ui-infra-card-standard ui-pos-standard">
            <div className="ui-infra-img-wrapper">
              <ImageCarousel imageArray={images.seminar} />
            </div>
            <div className="ui-infra-content">
              <div className="ui-infra-heading">Seminar Hall</div>
              <ReadMoreDesc text={seminarHallText} limit={120} />
            </div>
          </div>

          {/* 5. Computer Centre (Left Column, Row 3) */}
          <div className="ui-infra-card ui-infra-card-standard ui-pos-standard">
            <div className="ui-infra-img-wrapper">
              <ImageCarousel imageArray={images.compCentre} />
            </div>
            <div className="ui-infra-content">
              <div className="ui-infra-heading">Computer Centre</div>
              <ReadMoreDesc text={computerCentreText} limit={150} />
            </div>
          </div>

          {/* 6. Sick Room (Right Column, Row 3) */}
          <div className="ui-infra-card ui-infra-card-standard ui-pos-standard">
            <div className="ui-infra-img-wrapper">
              <ImageCarousel imageArray={images.sickroom} />
            </div>
            <div className="ui-infra-content">
              <div className="ui-infra-heading">Sick Room</div>
              <ReadMoreDesc text={sickRoomText} limit={100} />
            </div>
          </div>

          {/* 7. Footer: Common Room & Hostel */}
          <div className="ui-infra-card ui-infra-card-overlay ui-pos-footer">
            <div className="ui-infra-img-wrapper">
              <ImageCarousel imageArray={images.hostel} />
            </div>
            <div className="ui-infra-content">
              <div className="ui-infra-heading">Common Room</div>
              <ReadMoreDesc text={hostelText} limit={150} />
            </div>
          </div>

        </div>

        {/* --- Gallery Section --- */}
        <div className="ui-infra-gallery">
          <h2 className="ui-infra-gallery-title">View Gallery</h2>
          <div className="ui-infra-gallery-grid">
            <div className="ui-infra-gallery-item ui-gal-tall"><img src={images.g1} alt="G1" /></div>
            <div className="ui-infra-gallery-item"><img src={images.g2} alt="G2" /></div>
            <div className="ui-infra-gallery-item"><img src={images.g3} alt="G3" /></div>
            <div className="ui-infra-gallery-item"><img src={images.g4} alt="G4" /></div>
            <div className="ui-infra-gallery-item ui-gal-wide-3"><img src={images.g5} alt="G5" /></div>
            <div className="ui-infra-gallery-item"><img src={images.g6} alt="G6" /></div>
            <div className="ui-infra-gallery-item"><img src={images.g7} alt="G7" /></div>
            <div className="ui-infra-gallery-item"><img src={images.g8} alt="G8" /></div>
            <div className="ui-infra-gallery-item ui-gal-tall"><img src={images.g9} alt="G9" /></div>
            <div className="ui-infra-gallery-item ui-gal-wide-2"><img src={images.g10} alt="G10" /></div>
            <div className="ui-infra-gallery-item"><img src={images.g11} alt="G11" /></div>
          </div>
        </div>

      </div>
      <Footer />
    </>
  );
};

export default Infrastructure;